import { Link } from "react-router-dom";
import { BUSINESS, LOGO_URL, SERVICES, SERVICE_AREAS } from "../../mocks/businessData";

export default function Footer() {
  const topAreas = SERVICE_AREAS.slice(0, 16);

  return (
    <footer className="bg-stone-900 text-stone-300">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img
              src={LOGO_URL}
              alt="The Drapery & Blind Co."
              className="w-12 h-12 object-contain"
            />
            <div>
              <p className="text-white text-xs font-semibold tracking-[0.18em] uppercase">The Drapery</p>
              <p className="text-stone-400 text-xs tracking-[0.12em] uppercase">&amp; Blind Co.</p>
            </div>
          </div>
          <p className="text-stone-400 text-sm leading-relaxed mb-5">
            New Jersey&apos;s premier drapery &amp; blind cleaning specialists. Serving NJ, NY, PA &amp; CT for over 40 years.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center bg-stone-700 hover:bg-amber-700 rounded-sm transition-colors duration-300 cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-sm text-white" />
            </a>
            <a
              href={BUSINESS.google}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center bg-stone-700 hover:bg-amber-700 rounded-sm transition-colors duration-300 cursor-pointer"
              aria-label="Google Reviews"
            >
              <i className="ri-google-fill text-sm text-white" />
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.18em] uppercase mb-5 border-b border-stone-700 pb-3">
            <a id="footer-services" href="/services">Our Services</a>
          </h4>
          <ul className="space-y-2">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link
                  to="/services"
                  className="text-stone-400 hover:text-amber-500 text-sm transition-colors duration-200 cursor-pointer"
                >
                  {s.title} Cleaning
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.18em] uppercase mb-5 border-b border-stone-700 pb-3">
            <a id="footer-nav" href="/">Navigation</a>
          </h4>
          <ul className="space-y-2">
            {[
              { label: "Home", path: "/" },
              { label: "Services", path: "/services" },
              { label: "About Us", path: "/about" },
              { label: "Service Locations", path: "/location" },
            ].map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-stone-400 hover:text-amber-500 text-sm transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-6">
            <h4 className="text-white text-xs font-semibold tracking-[0.18em] uppercase mb-3">Hours</h4>
            <p className="text-amber-500 text-sm font-semibold">{BUSINESS.hours}</p>
            <p className="text-stone-500 text-xs mt-1">Emergency service available</p>
          </div>
        </div>

        {/* Contact + Areas */}
        <div>
          <h4 className="text-white text-xs font-semibold tracking-[0.18em] uppercase mb-5 border-b border-stone-700 pb-3">
            <a id="footer-contact" href={BUSINESS.phoneHref}>Contact</a>
          </h4>
          <div className="space-y-3 mb-6">
            <a
              href={BUSINESS.phoneHref}
              className="flex items-center gap-2 text-stone-300 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-amber-600 text-sm" />
              </span>
              <span className="text-sm font-semibold">{BUSINESS.phone}</span>
            </a>
            <div className="flex items-center gap-2 text-stone-400">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-fill text-amber-600 text-sm" />
              </span>
              <span className="text-sm">Belleville, NJ (Serving NJ, NY, PA, CT)</span>
            </div>
          </div>
          <h5 className="text-white text-xs font-semibold tracking-widest uppercase mb-3">Top Service Areas</h5>
          <div className="flex flex-wrap gap-1">
            {topAreas.slice(0, 10).map((area) => (
              <Link
                key={area}
                to="/location"
                className="text-xs text-stone-500 hover:text-amber-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {area} ·
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-600 text-xs">
            &copy; {new Date().getFullYear()} The Drapery &amp; Blind Co. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-amber-500 text-xs" />
            </span>
            <p className="text-stone-500 text-xs">340+ Five-Star Google Reviews</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
